import { atom } from 'jotai';

import { counterpartyGroupMemberDetailsQueryAtom } from '../_graphql/queryCounterpartyGroupMemberDetails';
import { counterpartyGroupMembersQueryAtom } from '../_graphql/queryCounterpartyGroupMembers';
import { counterpartyGroupsListQueryAtom } from '../_graphql/queryCounterpartyGroupsList';

import { accountsForCloneQueryAtom } from '~/modules/brokerage/_graphql/queryAccountsForClone';
import { atomFromRoutePath } from '~/shared/state';

export const $counterpartyGroupDetailPathParams = atomFromRoutePath(
  '/pricing/groups/:id' as const,
);

export const $counterpartyGroupId = atom((get) =>
  get($counterpartyGroupDetailPathParams)?.id
    ? String(get($counterpartyGroupDetailPathParams)?.id)
    : null,
);

export const $remoteCounterpartyGroup = counterpartyGroupsListQueryAtom(
  (get) => {
    const counterpartyGroupId = get($counterpartyGroupId);
    return {
      variables: {
        ids: counterpartyGroupId ? [counterpartyGroupId] : undefined,
        limit: 1,
      },
      skip: !counterpartyGroupId,
    };
  },
);

export const $remoteGroupMembers = counterpartyGroupMembersQueryAtom((get) => ({
  variables: {
    groupId: get($counterpartyGroupId) ?? '',
  },
  skip: !get($counterpartyGroupId),
}));

export const $isCounterpartyGroupLoading = atom((get) => {
  const data = get($remoteCounterpartyGroup);
  return data?.isLoading ?? false;
});

export const $counterpartyGroupError = atom((get) => {
  const data = get($remoteCounterpartyGroup);
  return data?.error ?? null;
});

export const $addAccountsSearchTerm = atom('');

export const $remoteAddAccountsResults = accountsForCloneQueryAtom((get) => ({
  variables: {
    searchTerm: get($addAccountsSearchTerm) || undefined,
  },
}));

export const $remoteMemberAccounts = accountsForCloneQueryAtom((get) => {
  const membersResult = get($remoteGroupMembers);
  const memberIds = (membersResult?.data as string[]) ?? [];
  return {
    variables: {
      ids: memberIds.length > 0 ? memberIds : undefined,
    },
    skip: memberIds.length === 0,
  };
});

export const $remoteMemberDetails = counterpartyGroupMemberDetailsQueryAtom(
  (get) => ({
    variables: {
      groupId: get($counterpartyGroupId) ?? '',
    },
    skip: !get($counterpartyGroupId),
  }),
);
